import { Box, IconButton, Modal, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';
import {
  BMRSection,
  BMRTitle,
  BMRValue
} from '../malnutritionScreening/glim/style';
import { AdultEPF } from './adultEPF';
import { PaediatricEPF } from './paediatricEPF';
import Line from '../../shared/components/line/index';
import { GridStyled } from './style';
import InfoIcon from '../../assets/icons/infoIcon.svg';
import { AddOnInfoModal } from '../../shared/components/modal/addOnInfoModal';

export const ENRSection = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const {
    patientInformation: { type },
    summary
  } = useAppSelector(metaDataSelector);
  return (
    <>
      {type === 'ADULT' ? (
        <>
          <AdultEPF />
          <GridStyled
            className="width-100"
            id="section-C"
            container
            sx={{ background: '#004F71', marginTop: '0px' }}
          >
            <Line color="#D9D9D6" height="0.0625rem" width="90%" />

            <Box
              sx={{
                display: 'flex',
                paddingTop: '1.25rem',
                gap: '15px'
              }}
            >
              <Typography
                sx={{
                  fontSize: '1.125rem',
                  lineHeight: '1.5rem',
                  fontFamily: 'BGBold',
                  fontWeight: '450',
                  textTransform: 'uppercase',
                  color: '#fff'
                }}
              >
                MALNUTRITION ASSESSMENT
              </Typography>
              <IconButton
                onClick={handleOpen}
                size="small"
                aria-label="info"
                sx={{
                  padding: 0,
                  alignItems: 'flex-start'
                }}
              >
                <img src={InfoIcon} alt="Info" width="20" height="20" />
              </IconButton>
            </Box>
            <BMRSection sx={{ margin: '0px 1.875rem' }}>
              <BMRTitle variant="h2">{'MUST:'}</BMRTitle>
              <BMRValue>{summary.malnutritionScreening.must}</BMRValue>
            </BMRSection>

            <BMRSection
              sx={{ margin: '0px 1.875rem', justifyContent: 'space-between' }}
              className="ht-auto"
            >
              <BMRTitle variant="h2" sx={{ width: '90%' }}>
                {'GLIM (Phenotypic-Etiological):'}
              </BMRTitle>
              <BMRValue>{summary.malnutritionScreening.glim}</BMRValue>
            </BMRSection>
            <BMRSection sx={{ margin: '0px 1.875rem' }}>
              <BMRTitle variant="h2">{'MST:'}</BMRTitle>
              <BMRValue>{summary.malnutritionScreening.mst}</BMRValue>
            </BMRSection>
            <Line color="#D9D9D6" height="0.0625rem" width="90%" />
            <Typography
              sx={{
                fontSize: '1.125rem',
                lineHeight: '1.5rem',
                fontFamily: 'BGBold',
                fontWeight: '450',
                textTransform: 'uppercase',
                color: '#fff'
              }}
            >
              MUSCLE ASSESSMENT
            </Typography>
            <BMRSection sx={{ margin: '0px 1.875rem' }}>
              <BMRTitle variant="h2">{'SARC-F:'}</BMRTitle>
              <BMRValue>{summary.muscleScreening.sarcf}</BMRValue>
            </BMRSection>
            <BMRSection sx={{ margin: '0px 1.875rem' }}>
              <BMRTitle variant="h2">{'Handgrip Strength (cm):'}</BMRTitle>
              <BMRValue>{summary.muscleScreening.handgripStrength}</BMRValue>
            </BMRSection>
            <BMRSection sx={{ margin: '0px 1.875rem' }}>
              <BMRTitle variant="h2">{'Calf Circumference (cm):'}</BMRTitle>
              <BMRValue>{summary.muscleScreening.calfCircumference}</BMRValue>
            </BMRSection>
          </GridStyled>
        </>
      ) : (
        <PaediatricEPF />
      )}
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AddOnInfoModal
          heading1={`MUST`}
          description1={` = Malnutrition Universal Screening Tool`}
          heading2={`GLIM`}
          description2={` = Global Leadership Initiative in Malnutrition`}
          heading3={`MST`}
          description3={` = Malnutrition Screening Tool`}
          heading4={`SARC-F`}
          description4={` = Strength, Ambulation, Rise from a chair, Climb stairs, Falls`}
          onClose={handleClose}
        />
      </Modal>
    </>
  );
};
